<template>
  <div class="mainFooter">
    <div class="bottomLogo ">
      <nav class="navbar navbar-light bg-transparent">
        <div class="leftIcons">
          <a href="https://www.arcadis.com/en/australia/" target="_blank">
            <img class="siteLogoLeft" src="img/assets/logos/In8.svg">
          </a>
          <a href="https://www.bentley.com/en/products/brands/projectwise" target="_blank">
            <img class="siteLogoLeft" src="img/assets/logos/ProjWis.svg">
          </a>
        </div>
        <div style="width:50vw;"></div>
        <div>
          <img src="img/assets/logos/Arc&GHDlogo.svg" class="siteLogoRight">
        </div>
      </nav>
      
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // year: new Date().getFullYear()
      // year: 2020
    };
  }
};
</script>
<style scoped>
  .mainFooter {
    background-color:transparent;
    width: 100vw;
  }
  .bottomLogo {
    /* padding-left:16px; */
    position: absolute;
    bottom: 0;
  }
  .leftIcons {
    width: 30vw;
  }
  .siteLogoLeft {
    height: 4.5vh;
    margin-left: 2vw;
    margin-bottom: 2vh;
  }
  .siteLogoRight {
    height: 7vh;
    /* padding-right: 1vw; */
    margin-bottom: 1vh;
  }
</style>
